import React from 'react';
import PropTypes from 'prop-types';
import Treeview from '../../components/blanks/common/Treeview';

function Labels({ labels, onLabelSelect, currentLabel }) {
  return (
    <Treeview
      data={labels}
      currentItem={currentLabel}
      setCurrentItem={onLabelSelect}
    />
  );
}

Labels.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  onLabelSelect: PropTypes.func.isRequired,
  currentLabel: PropTypes.number,
};

Labels.defaultProps = {
  currentLabel: null,
};

export default Labels;
